/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link } from '@coursera/cds-core';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import Card from 'bundles/shared-articles/components/ArticleCard';
import type { ArticleCardProps as CardProps } from 'bundles/shared-articles/types';
import useEstimatedReadTimeData from 'bundles/unified-seo-content-common/hooks/useEstimatedReadTimeData';

type InputProps = CardProps & {
  slug: string;
  trackingName: string;
};

export type Props = InputProps;

const styles = {
  link: () => css`
    border-radius: var(--cds-spacing-100);
    display: block;
    transition: box-shadow ease-out 250ms;
    height: 100%;

    &:hover,
    &:focus-visible {
      box-shadow: 0 2px 10px var(--cds-color-neutral-primary);
      outline: none;
    }

    &:hover,
    &:focus,
    &:active {
      text-decoration: none;
    }

    h2 {
      -webkit-line-clamp: unset;
      overflow: unset;
      text-overflow: unset;
    }
  `,
};

export const OnsiteRecommendationCard = ({
  slug,
  title,
  subtitle,
  trackingName,
  metadata,
  alwaysShowSubtitle,
}: Props) => {
  const { estimatedReadTimeLabel } = useEstimatedReadTimeData({ slug });
  const articleId = `recommended-article-${slug}`;

  return (
    <Link
      css={styles.link}
      component={TrackedA}
      data={{ slug, title }}
      href={`/articles/${slug}?trk_ref=${trackingName}`}
      trackingName={trackingName}
      variant="quiet"
      aria-labelledby={articleId}
    >
      <Card
        id={articleId}
        title={title}
        subtitle={subtitle}
        metadata={{ ...metadata, estimatedReadingTime: estimatedReadTimeLabel }}
        alwaysShowSubtitle={alwaysShowSubtitle}
      />
    </Link>
  );
};

export default OnsiteRecommendationCard;
